<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		value = $bindable(),
		element = $bindable(),
		class: className = '',
		required = false,
		disabled = false,
		error = null,
		label = null,
		unitLabel = null,
		onchange = null,
		...props
	} = $props();
</script>

<InputWrapper {label} {error} class={className}>
	<input
		bind:value
		bind:this={element}
		type="text"
		class={[
			'border-indow-grey-light w-full content-center rounded-md',
			{ 'bg-indow-grey-light cursor-not-allowed': disabled },
			{ 'border-indow-red': error },
			{ 'pr-8': unitLabel },
		]}
		aria-invalid={error ? true : undefined}
		{name}
		{required}
		{disabled}
		{onchange}
		{...props}
	/>
	{#if unitLabel}
		<span
			class="text-indow-grey pointer-events-none absolute right-0 h-full px-3 py-4"
		>
			{unitLabel}
		</span>
	{/if}
</InputWrapper>
